// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 3,
  argument: "An exhortation to the practice of virtue.",
  verses: [
    { n: 1, text: "My son, forget not my law, and let thy heart keep my commandments." },
    { n: 2, text: "For they shall add to thee length of days, and years of life, and peace." },
    { n: 3, text: "Let not mercy and truth leave thee, put them about thy neck, and write them in the tables of thy heart." },
    { n: 4, text: "And thou shalt find grace, and good understanding before God and men." },
    { n: 5, text: "Have confidence in the Lord with all thy heart, and lean not upon thy own prudence." },
    { n: 6, text: "In all thy ways think on him, and he will direct thy steps." },
    { n: 7, text: "Be not wise in thy own conceit: fear God, and depart from evil:" },
    { n: 8, text: "For it shall be health to thy navel, and moistening to thy bones." },
    { n: 9, text: "Honour the Lord with thy substance, and give him of the first of all thy fruits;" },
    { n: 10, text: "And thy barns shall be filled with abundance, and thy presses shall run over with wine." },
    { n: 11, text: "My son, reject not the correction of the Lord: and do not faint when thou art chastised by him:" },
    { n: 12, text: "For whom the Lord loveth, he chastiseth: and as a father in the son he pleaseth himself." },
    { n: 13, text: "Blessed is the man that findeth wisdom, and is rich in prudence:" },
    { n: 14, text: "The purchasing thereof is better than the merchandise of silver, and her fruit than the chief and purest gold:" },
    { n: 15, text: "She is more precious than all riches: and all the things that are desired, are not to be compared to her." },
    { n: 16, text: "Length of days is in her right hand, and in her left hand riches and glory." },
    { n: 17, text: "Her ways are beautiful ways, and all her paths are peaceable." },
    { n: 18, text: "She is a tree of life to them that lay hold on her: and he that shall retain her is blessed." },
    { n: 19, text: "The Lord by wisdom hath founded the earth, hath established the heavens by prudence." },
    { n: 20, text: "By his wisdom the depths have broken out, and the clouds grow thick with dew." },
    { n: 21, text: "My son, let not these things depart from thy eyes: keep the law and counsel:" },
    { n: 22, text: "And there shall be life to thy soul, and grace to thy mouth." },
    { n: 23, text: "Then shalt thou walk confidently in thy way, and thy foot shall not stumble:" },
    { n: 24, text: "If thou sleep, thou shalt not fear: thou shalt rest, and thy sleep shall be sweet." },
    { n: 25, text: "Be not afraid of sudden fear, nor of the power of the wicked falling upon thee." },
    { n: 26, text: "For the Lord will be at thy side, and will keep thy foot that thou be not taken." },
    { n: 27, text: "Do not withhold him from doing good, who is able: if thou art able, do good thyself also." },
    { n: 28, text: "Say not to thy friend: Go, and come again: and to-morrow I will give to thee: when thou canst give at present." },
    { n: 29, text: "Practise not evil against thy friend, when he hath confidence in thee." },
    { n: 30, text: "Strive not against a man without cause, when he hath done thee no evil." },
    { n: 31, text: "Envy not the unjust man, and do not follow his ways." },
    { n: 32, text: "For every mocker is an abomination to the Lord, and his communication is with the simple." },
    { n: 33, text: "Want is from the Lord in the house of the wicked: but the habitations of the just shall be blessed." },
    { n: 34, text: "He shall scorn the scorners, and to the meek he will give grace." },
    { n: 35, text: "The wise shall possess glory: the promotion of fools is disgrace." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "My son. God speaks, or the master instructs his disciple,", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "(Calmet) — We must remember and love instruction, and reduce it to practice.", attribution: "Worthington" }
    ] },
    { verse: 2, notes: [
      { text: "Peace. These prefigured more substantial blessings.", attribution: "Calmet" }
    ] },
    { verse: 3, notes: [
      { text: "Truth. Be kind and faithful to all, Genesis xxiv. 27., and Psalm xxiv. 10.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Good. Septuagint, \"forecast good before the Lord and men.\" St. Paul seems to allude to this version, Romans xii. 17., and 2 Corinthians viii. 22.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "All. God will have nothing by halves. — Lean not. By pride, 2 Corinthians xii. 13. All must be referred to God. (Calmet) — In him we may safely trust.", attribution: "Worthington" }
    ] },
    { verse: 8, notes: [
      { text: "Bones. Thou shalt enjoy perfect health.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Fruits. Septuagint add, \"of justice;\" to intimate that no presents will be acceptable, which have been unjustly acquired.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Him. Correction is rather a proof of love than of anger, Psalm iii. 19. (Calmet) — God thus shews that he approves of his servants; and therefore his other promises, which seem of a temporal nature, must be understood with reference to the next life.", attribution: "Worthington" }
    ] },
    { verse: 12, notes: [
      { text: "And as. Septuagint, \"but he scourgeth every son whom he receiveth,\" as St. Paul quotes this passage, Hebrews xii. 6. The verb is now wanting in Hebrew, or ceab; \"as a father\" may signify \"scourgeth, in piel, (Menochius) with i prefixed.", attribution: "Calmet" }
    ] },
    { verse: 15, notes: [
      { text: "Riches. Hebrew peninim, (Haydock) \"pearls,\" Job xxviii. 18.", attribution: "Calmet" }
    ] },
    { verse: 16, notes: [
      { text: "Glory. Her hands are full, and she grants favours with profusion, (Haydock) as with both hands, promising eternal life.", attribution: "Worthington" }
    ] },
    { verse: 18, notes: [
      { text: "Life. Like that planted in paradise, Genesis ii. 9.", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "Wisdom. Hitherto he had spoken of that virtue. Now he treats of the uncreated wisdom, (Calmet) which is God the Son. (Menochius) (Jansenius)", attribution: "St. Gregory, Mor. xii. 4." }
    ] },
    { verse: 20, notes: [
      { text: "Out. The higher and lower waters being divided, (Calmet) or the channels formed to receive the waters. (Piscator) — It may also speak of the deluge. (Ven. Bede) — With. Hebrew, \"have distilled dew.\" This is so copious, as to resemble rain in Palestine, Judges vi. 37., and 2 Kings xvii. 12.", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "Mouth. There have been wise and virtuous men afflicted,", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Able. Protestants, \"withhold not good from them to whom it is due, when it is in the power of thine hand to do it.\" Relieve the distressed. (Haydock) — They have a title to that wealth, since those who possess it are bound to relieve the indigent. (Calmet) — Septuagint, \"refrain not from doing good,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Present. Alms in season are doubly valuable. (Worthington) — Antigonus acquired the title of Doson, \"about to give,\" as he never gave, (Plutarch) but only promised.", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "Cause. We may defend ourselves; but herein great discretion is necessary. (Calmet) — Cum pari contendere anceps est: cum superiore furiosum; cum inferiore sordidum.", attribution: "Seneca, Prov." }
    ] },
    { verse: 31, notes: [
      { text: "Ways. Of injustice. Seek not to attain his prosperity by the same means.", attribution: "Calmet" }
    ] },
    { verse: 33, notes: [
      { text: "Want. Hebrew, \"a curse.\" — Shall be. Hebrew, \"he blesseth.\"", attribution: "Haydock" }
    ] },
    { verse: 34, notes: [
      { text: "Scorners. Literally, \"he will delude the scorners.\" (Haydock) — He will treat them as they would treat others, Psalm xvii. 27. (Calmet) — Septuagint, \"the Lord resisteth the proud,\" &c. So the apostles quote this passage, 1 Peter v. 5., and James iv. 6.", attribution: "Haydock" }
    ] },
    { verse: 35, notes: [
      { text: "Disgrace. They are seen by more, and their fall is more dangerous. (Calmet) — \"A fool extols what is ignominious.\" (Pagnin)", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
